/* eslint-disable eqeqeq */
import {
  Html5QrcodeCameraScanConfig,
  Html5QrcodeFullConfig,
  QrcodeErrorCallback,
  QrcodeSuccessCallback,
  Html5Qrcode,
} from "html5-qrcode";
import { useEffect, useRef } from "react";

// Creates the configuration object for Html5QrcodeScanner.
const createConfig = (
  props: Html5QrcodeCameraScanConfig
): Html5QrcodeCameraScanConfig => {
  const config: Html5QrcodeCameraScanConfig = {
    fps: undefined,
  };
  if (props.fps) {
    config.fps = props.fps;
  }
  if (props.qrbox) {
    config.qrbox = props.qrbox;
  }
  if (props.aspectRatio) {
    config.aspectRatio = props.aspectRatio;
  }
  if (props.disableFlip !== undefined) {
    config.disableFlip = props.disableFlip;
  }
  return config;
};

interface Html5QrCodeProps
  extends Partial<Html5QrcodeFullConfig>,
    Html5QrcodeCameraScanConfig {
  qrCodeSuccessCallback?: QrcodeSuccessCallback;
  qrCodeErrorCallback?: QrcodeErrorCallback;
  /**
   * @deprecated we don't use this soon
   */
  cameraConfig?: Partial<MediaTrackConstraints>;
}

const Html5QrcodePlugin = ({ ...rest }: Html5QrCodeProps) => {
  const previewRef = useRef<HTMLDivElement>(null);
  const memoizedResultHandler = useRef(rest.qrCodeSuccessCallback);
  const memoizedErrorHandler = useRef(rest.qrCodeErrorCallback);

  useEffect(() => {
    memoizedResultHandler.current = rest.qrCodeSuccessCallback;
  }, [rest.qrCodeSuccessCallback]);

  useEffect(() => {
    memoizedErrorHandler.current = rest.qrCodeErrorCallback;
  }, [rest.qrCodeErrorCallback]);

  useEffect(() => {
    if (!previewRef.current) return;
    const html5QrcodeScanner = new Html5Qrcode(previewRef.current.id);
    const config = createConfig(rest);
    const didStart = html5QrcodeScanner
      .start(
        { facingMode: "environment" },
        config,
        memoizedResultHandler.current,
        memoizedErrorHandler.current
      )
      .then(() => true);
    return () => {
      didStart
        .then(() => html5QrcodeScanner.stop())
        .catch(() => {
          console.log("Error stopping scanner");
        });
    };
  }, [previewRef, memoizedResultHandler, memoizedErrorHandler]);

  return <div id="preview" ref={previewRef} />;
};

export default Html5QrcodePlugin;
